/** @format */

import {CampaignMediaplanStat, ParsedTables, Recommendation} from '../types';
import {DEVICE_TYPE_MAP, OS_TYPE_MAP} from '../constants';

export function parseJsonToTableData(
  recommendationGroups: unknown,
  campaignMediaplanStats?: CampaignMediaplanStat[],
  kpiName?: string,
  targetKpi?: number,
): ParsedTables[] {
  if (!recommendationGroups || !Array.isArray(recommendationGroups)) return [];

  const campaignMap = new Map<string, string>();
  if (campaignMediaplanStats) {
    campaignMediaplanStats.forEach(campaign => {
      if (campaign.campaignId && campaign.accountName) {
        campaignMap.set(campaign.campaignId, campaign.accountName);
      }
    });
  }

  return recommendationGroups.map(group => {
    const entityType = group.entityType;
    const recommendations = group.recommendations || [];

    // Находим максимальные значения по модулю для текущей группы
    let maxKpiFact = 0;
    let maxForecastKpi = 0;
    let maxForecastBudget = 0;

    recommendations.forEach((item: Recommendation) => {
      const kpi = item.justification?.kpi;
      const forecastKpi = item.forecast?.impactKpiValue;
      const forecastBudget = item.forecast?.impactBudgetValue;

      if (kpi != null) {
        // Для ДРР используем новую формулу расчета
        if (
          kpiName === 'ДРР' &&
          item.justification?.budget &&
          item.justification?.kpi &&
          targetKpi
        ) {
          const calculatedValue =
            item.justification.budget -
            (item.justification.budget / item.justification.kpi) * targetKpi;
          maxKpiFact = Math.max(maxKpiFact, Math.abs(calculatedValue));
        } else {
          maxKpiFact = Math.max(maxKpiFact, Math.abs(kpi));
        }
      }
      if (forecastKpi != null) {
        maxForecastKpi = Math.max(maxForecastKpi, Math.abs(forecastKpi));
      }
      if (forecastBudget != null) {
        maxForecastBudget = Math.max(maxForecastBudget, Math.abs(forecastBudget));
      }
    });

    const tableRows = recommendations.map((item: Recommendation, index: number) => {
      let segment = '';
      switch (entityType) {
        case 'device':
          segment = DEVICE_TYPE_MAP[item.device || ''] || item.device || 'N/A';
          break;
        case 'os':
          segment = OS_TYPE_MAP[item.os || ''] || item.os || 'N/A';
          break;
        case 'location':
          segment = item.location || 'N/A';
          break;
        case 'segment':
          let gender = '';
          if (item.segmentGender === 'GENDER_FEMALE' || item.segmentGender === 'F') {
            gender = 'Женщины';
          } else if (item.segmentGender === 'GENDER_MALE' || item.segmentGender === 'M') {
            gender = 'Мужчины';
          }

          let age = '';
          if (item.segmentAge) {
            if (item.segmentAge.startsWith('AGE_')) {
              age = item.segmentAge.replace('AGE_', '').replace('_', '-');
            } else {
              age = item.segmentAge.replace('_', '-');
            }
          }

          segment = `${gender} ${age}`.trim() || 'N/A';
          break;
        case 'placement':
          segment = item.placement || 'N/A';
          break;
        case 'ad':
          segment = item.entityId || 'N/A';
          break;
        case 'campaign':
          segment = item.campaignName || 'N/A';
          break;
        case 'group':
          segment = item.groupName || 'N/A';
          break;
        case 'keyword':
          segment = item.keyword || 'N/A';
          break;
        default:
          segment = 'N/A';
      }

      const recommendation = item.actionType
        ? `${item.actionType} ${item.actionValue ?? ''}${item.actionUnits === 'percent' ? '%' : ''}`.trim()
        : '—';

      const accountName = item.campaignId ? campaignMap.get(item.campaignId) : undefined;

      const budget = item.justification?.budget ?? null;
      const kpi = item.justification?.kpi;
      const revenue = budget != null && kpi != null && kpi !== 0 ? budget / (kpi / 100) : null;

      return {
        number: index + 1,
        segmentName: segment,
        groupId: item.groupId || '',
        campaignId: item.campaignId || '',
        campaignName: item.campaignName || '',
        accountName,
        kpiFact: item.justification?.kpi ?? null,
        budget,
        revenue,
        actionType: item.actionType,
        actionValue: item.actionValue,
        actionUnits: item.actionUnits,
        recommendation,
        forecastKpi: item.forecast?.impactKpiValue ?? null,
        forecastBudget: item.forecast?.impactBudgetValue ?? null,
        justification: item.justification,
        isCollapseSubRows: true,
        subRows: [
          {
            essence: item.essence || '',
            hypothesisDigital: item.hypothesisDigital || '',
            hypothesisTheory: item.hypothesisTheory || '',
            notes: item.notes || '',
          },
        ],
      };
    });

    return {
      groupKey: entityType,
      data: tableRows,
      maxKpiFact,
      maxForecastKpi,
      maxForecastBudget,
    };
  });
}
